import React from 'react';
import { Box, Button, styled, themeGet } from '@qwealth/qcore';
import { ReactElement, useState } from 'react';
import { truncate } from 'lodash';
interface TruncateTextProps {
  text: string;
  maxLength?: number;
}

const StyledShowMoreTextButton = styled(Box)`
  as: span;
  margin-left: ${themeGet('space.default')};
  display: inline-block;
`;

const StyledTextContainer = styled(Box)`
  overflow: auto;
  word-break: break-all;
`;

const TruncateTextByNumberOfChars: React.FC<TruncateTextProps> = ({ text, maxLength = 100 }): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  const displayedText = isExpanded ? text : truncate(text, { length: maxLength, separator: ' ' });
  const showToggleButton = text.length > maxLength;

  return (
    <Box>
      <StyledTextContainer>
        {displayedText}
        {showToggleButton && (
          <StyledShowMoreTextButton onClick={toggleText}>
            <Button variant="text" size="small">
              {isExpanded ? 'Show Less' : 'Show More'}
            </Button>
          </StyledShowMoreTextButton>
        )}
      </StyledTextContainer>
    </Box>
  );
};

export default TruncateTextByNumberOfChars;
